import {Trans} from '@ui/i18n/trans';
import {cn} from '@ui/utils/cn';
import {useEffect, useState} from 'react';

type ConnectionStatus = 'ok' | 'offline' | 'resuming';

export function ConnectionStatusBar() {
  const [status, setStatus] = useState<ConnectionStatus>(() =>
    typeof navigator !== 'undefined' && navigator.onLine === false
      ? 'offline'
      : 'ok',
  );

  useEffect(() => {
    const goOffline = () => setStatus('offline');
    const goOnline = () => {
      setStatus('resuming');
      window.setTimeout(() => {
        setStatus(prev => (prev === 'resuming' ? 'ok' : prev));
      }, 4500);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (status === 'ok') {
    return null;
  }

  return (
    <div
      role="status"
      className={cn(
        'fixed inset-x-0 z-50 px-4 py-2 text-center text-sm font-medium shadow-lg max-lg:bottom-14 lg:bottom-0',
        status === 'offline'
          ? 'bg-foreground text-background'
          : 'bg-primary text-primary-foreground',
      )}
    >
      {status === 'offline' ? (
        <Trans message="You are offline. Uploads are paused and will resume when you reconnect." />
      ) : (
        <Trans message="Back online, resuming…" />
      )}
    </div>
  );
}
